<template>
  <div class="ErrorBlank">
    <div class="ErrorBlank-body">
      <div class="ErrorBlank-body-backDoor" @click="backDoor">返回登录页</div>
    </div>
  </div>
</template>

<script>
import auth from "@/util/auth"
import store from "@/store";
import LoginApi from "@/api/LoginApi";
export default {
  name: "ErrorBlank",
  data() {
    return {
    };
  },
  methods: {
    backDoor() {
      //清除标签 
      // this.$store.commit("DEL_ALL_TAG");
      // this.storageHandler.clearStorage();
      // let clientId = process.env.VUE_APP_SSO_ID;
      // this.storageHandler.clearSessionStorage();
      // let logOutUrl =
      //   window.location.href.split("/cncecPms")[0] + "/cncecPms/login";
      // window.location.href = `${
      //   process.env.VUE_APP_SSO_HOST
      //   }/sso/logout?redirectUrl=${encodeURIComponent(
      //     logOutUrl
      //   )}&clientId=${clientId}`;
        

        let loginApi = new LoginApi();
        let params = { token: store.getters.token };
        if(store.getters.token) {
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearLock");
          this.$store.dispatch("clearTag");
          sessionStorage.removeItem('appTempId');
          sessionStorage.removeItem('newPagePath');
          localStorage.removeItem("token")
          auth.removeToken()
          let logOutUrl = window.location.origin + "/login";
          window.location.href = `${
            process.env.SSO_HOST
          }/ibs/loginOut?redirectUrl=${encodeURIComponent(logOutUrl)}&appId=${
            process.env.SSO_APP_ID
          }`;
        } else {
          loginApi.logout(params).then(res => {
            this.$store.dispatch("clearToken");
            this.$store.dispatch("clearLock");
            this.$store.dispatch("clearTag");
            sessionStorage.removeItem('appTempId');
            sessionStorage.removeItem('newPagePath');
            localStorage.removeItem("token")
            auth.removeToken()
            let logOutUrl = window.location.origin + "/login";
            window.location.href = `${
              process.env.SSO_HOST
            }/ibs/loginOut?redirectUrl=${encodeURIComponent(logOutUrl)}&appId=${
              process.env.SSO_APP_ID
            }`;
          });
        }
    }
  }
};
</script>
<style lang="scss" scoped>
.ErrorBlank {
  .ErrorBlank-body {
    height: 100vh;
    width: 100vw;
    background: url("../../assets/image/noRole.png") no-repeat;
    background-position: center;
    position: relative;
    &-backDoor {
      color: #409eff;
      font-size: 18px;
      font-weight: 600;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(0, 60%);
    }
    &-backDoor:hover {
      cursor: pointer;
    }
  }
}
</style>
